import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CostEventPriceListPage } from "src/components/views/erp/common/costEvents/CostEventPriceListPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/common/costEventPriceLists")({
	staticData: { title: i18n.t("price_lists"), legacyViewKey: "costEventPriceListPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CostEventPriceListPage />;
}
